module.exports = __webpack_public_path__ + "media/video_2023-06-14_20-22-40.2074e251.mp4";